const parseMultipleInfoInline = (param1, param2) => {
  return param1 && param2 ? `${param1} - ${param2}` : param1 || param2
}

export default parseMultipleInfoInline
